import React from 'react';
import TextCell from './TextCell';
import SortHeaderCell from './SortHeaderCell';
import { Table, Column, Cell } from 'fixed-data-table';
import * as actions from '../redux/actions';
import DataTableUtil from '../DataTableUtil';
import Storage from '../Storage';
import { SortTypes } from '../Constants';
import BaseLayout from './pages/BaseLayout';

const FILTER_COLUMNS = [
  'srcorg',
  'srcloc',
  'dstorg',
  'dstloc',
  'status',
  'startdate',
  'completedate',
];
const DEFAULT_COL_SORT_DIRS = { startdate: SortTypes.DESC };
const DEFAULT_TABLE_WIDTH = 1200;
const DEFAULT_TABLE_HEIGHT = 500;

function getFilterKey(tableTitle = 'SosdbG2CopyHistory') {
  return tableTitle + ' : filterText';
}

function getColSortKey(tableTitle = 'SosdbG2CopyHistory') {
  return tableTitle + ' : columnSortDirs';
}

class SosdbG2CopyHistory extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showdetail: false,
      filterText: Storage.getSessionItem(getFilterKey(props.tableTitle)) || '',
      columnSortDirs:
        Storage.getSessionItem(getColSortKey(props.tableTitle)) || DEFAULT_COL_SORT_DIRS,
    };

    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
  }

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(actions.getSosdbG2ConvertHistoryCopyList());
  }

  handleRowClick(index, data) {
    let row = data[index];
    this.setState({
      detail: row,
      showdetail: true,
    });
  }

  backtotable() {
    this.setState({
      showdetail: false,
    });
  }

  handleSortChange(columnKey, sortDir) {
    let value = { [columnKey]: sortDir };
    this.setState({ columnSortDirs: value }, () => {
      Storage.setSessionItem(getColSortKey(this.props.tableTitle), value);
    });
  }

  handleFilter(e) {
    if (!e.target.value) {
      this.setState({ filterText: '' }, () => {
        Storage.setSessionItem(getFilterKey(this.props.tableTitle), '');
      });
      return;
    }

    const filterBy = this.refs.filterInput.value.toLowerCase();
    this.setState({ filterText: filterBy }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle), filterBy);
    });
  }

  parseResult(result) {
    if (!result) return '';
    console.log('***********', JSON.parse(result));
    return JSON.parse(result);
  }

  getUseInv(useInv) {
    if (useInv == null) return '';
    if (useInv) return 'Yes';
    else return 'No';
  }

  renderDetail() {
    let detail = this.state.detail;
    let tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;
    let result = this.parseResult(this.state.detail.results);

    return (
      <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
        <div className='pure-g pure-u-1 card-label button-secondary'>
          <div
            onClick={this.backtotable.bind(this)}
            style={{ display: 'block', textAlign: 'left', position: 'fixed' }}
          >
            <i className='fa fa-fw fa-arrow-left' />
          </div>
          {result.orgname} | {result.locname}
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1-5 small-paddingleft'>Source Customer</div>
          <div className='pure-u-4-5'>{result.srcorgname}</div>
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1-5 small-paddingleft'>Source Location</div>
          <div className='pure-u-4-5'>{result.srclocname}</div>
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1-5 small-paddingleft'>Target Org</div>
          <div className='pure-u-4-5'>{result.orgname}</div>
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1-5 small-paddingleft'>Target Location</div>
          <div className='pure-u-4-5'>{result.locname}</div>
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1-5 small-paddingleft'>Include Inventory Levels</div>
          <div className='pure-u-4-5'>{this.getUseInv(result.useinv)}</div>
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1-5 small-paddingleft'>Status</div>
          <div className='pure-u-4-5'>{result.status}</div>
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1-5 small-paddingleft'>Total Source Products</div>
          <div className='pure-u-4-5'>{result.items}</div>
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1-5 small-paddingleft'>Products Copied</div>
          <div className='pure-u-4-5'>{result.prdinsertcnt}</div>
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1-5 small-paddingleft'>Products Updated</div>
          <div className='pure-u-4-5'>{result.prdupdatecnt}</div>
        </div>
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1 small-paddingleft'>
            <b>Error</b>
          </div>
        </div>
        {result.errors.length > 0 ? (
          result.errors.map((info) => {
            return (
              <div className='pure-u-1 detail-row'>
                <div className='pure-u-1 small-paddingleft'>{info}</div>
              </div>
            );
          })
        ) : (
          <div className='pure-u-1 detail-row' />
        )}
        <div className='pure-u-1 detail-row'>
          <div className='pure-u-1 small-paddingleft'>
            <b>Info</b>
          </div>
        </div>
        {result.infos.length > 0 ? (
          result.infos.map((info, index) => {
            return (
              <div className='pure-u-1 detail-row' key={index}>
                <div className='pure-u-1 small-paddingleft'>{info}</div>
              </div>
            );
          })
        ) : (
          <div className='pure-u-1 detail-row' />
        )}
      </div>
    );
  }

  render() {
    const { filterText, columnSortDirs } = this.state;
    const { g2ConvertHistoryList } = this.props;
    const dataList = DataTableUtil.filterList(
      g2ConvertHistoryList,
      filterText,
      FILTER_COLUMNS,
      columnSortDirs
    );
    const size = g2ConvertHistoryList.length;

    let tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;
    let tableHeight = BaseLayout.calcTableHeight(g2ConvertHistoryList) || DEFAULT_TABLE_HEIGHT;

    return (
      <div>
        {this.state.showdetail ? (
          this.renderDetail()
        ) : (
          <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
            <div className='pure-g pure-u-1 card-label button-secondary'>
              <i className='fa fa-fw fa-files-o' />
              {this.props.tableTitle}
              <input
                className='table-search'
                type='search'
                placeholder='Search'
                ref='filterInput'
                value={filterText}
                onChange={this.handleFilter}
              />
            </div>
            <Table
              onRowClick={(event, index) => {
                console.log('dd', this, index, dataList);
                this.handleRowClick(index, dataList);
              }}
              rowsCount={dataList.length}
              rowHeight={50}
              headerHeight={50}
              width={tableWidth}
              height={tableHeight}
              {...this.props}
            >
              <Column
                header={<Cell>#</Cell>}
                cell={(props) => (
                  <Cell {...props}>
                    <span style={{ fontSize: 10 }}>{props.rowIndex + 1}</span>
                  </Cell>
                )}
                fixed={true}
                width={30}
                align='right'
              />
              <Column
                columnKey='srcorg'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.srcorg}
                  >
                    Source Customer
                  </SortHeaderCell>
                }
                cell={(props) => (
                  <Cell {...props} className='main-cell' style={{ color: 'black' }}>
                    {this.parseResult(dataList[props.rowIndex].results).srcorgname}
                  </Cell>
                )}
                fixed={true}
                width={180}
              />
              <Column
                columnKey='srcloc'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.srcloc}
                  >
                    Location
                  </SortHeaderCell>
                }
                cell={(props) => (
                  <Cell {...props}>
                    {this.parseResult(dataList[props.rowIndex].results).srclocname}
                  </Cell>
                )}
                fixed={true}
                width={180}
              />
              <Column
                columnKey='dstorg'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.dstorg}
                  >
                    Target Org
                  </SortHeaderCell>
                }
                cell={(props) => (
                  <Cell {...props}>
                    {this.parseResult(dataList[props.rowIndex].results).orgname}
                  </Cell>
                )}
                fixed={true}
                width={180}
              />
              <Column
                columnKey='dstloc'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.dstloc}
                  >
                    Target Location
                  </SortHeaderCell>
                }
                cell={(props) => (
                  <Cell {...props}>
                    {this.parseResult(dataList[props.rowIndex].results).locname}
                  </Cell>
                )}
                fixed={true}
                width={180}
              />
              <Column
                columnKey='status'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.status}
                  >
                    Status
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='status' />}
                fixed={true}
                width={80}
              />
              <Column
                columnKey='startdate'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.startdate}
                  >
                    Start date
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='startdate' />}
                fixed={true}
                width={180}
              />
              <Column
                columnKey='completedate'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.completedate}
                  >
                    Complete date
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='completedate' />}
                fixed={true}
                width={180}
              />
            </Table>
            <div className='pure-g' style={{ padding: '5px 0' }}>
              <div className='pure-u-1-3'>
                {dataList.length < size ? (
                  <span>
                    Showing {dataList.length} entries (filtered from {size} total entries)
                  </span>
                ) : (
                  <span>
                    Showing {dataList.length} of {size}
                  </span>
                )}
              </div>
              <div className='pure-u-1-3'></div>
              <div className='pure-u-1-3' style={{ textAlign: 'right' }}></div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SosdbG2CopyHistory;



// WEBPACK FOOTER //
// ./src/components/SosdbG2CopyHistory.js